import { __read } from "tslib";
import { getScaleTicks, getScaleCenterPosition, } from '@keen.io/charts-utils';
import { Orientation } from '../../../../types';
var TICK_ALIGN = 0.5;
export var EDGE_TICK_ALIGN = 4;
export var generateTicks = function (_a) {
    var scale = _a.scale, tickSize = _a.tickSize, _b = _a.orientation, orientation = _b === void 0 ? Orientation.HORIZONTAL : _b, scaleSettings = _a.scaleSettings, x = _a.x, y = _a.y;
    var _c = getScaleTicks(scale, scaleSettings), values = _c.ticks, ticksPrecision = _c.ticksPrecision;
    var ticks = [];
    var position = 'bandwidth' in scale ? getScaleCenterPosition(scale) : scale;
    var getX = function (value) {
        return orientation === Orientation.HORIZONTAL ? position(value) : x + TICK_ALIGN;
    };
    var getY = function (value) {
        return orientation === Orientation.HORIZONTAL ? y - TICK_ALIGN : position(value);
    };
    values.forEach(function (value) {
        ticks.push({
            size: tickSize,
            text: value,
            x: getX(value),
            y: getY(value),
        });
    });
    if ('bandwidth' in scale && orientation === Orientation.HORIZONTAL) {
        var _d = __read(scale.range(), 2), scaleStart = _d[0], scaleEnd = _d[1];
        ticks.push({
            size: tickSize + EDGE_TICK_ALIGN,
            x: scaleStart,
            y: y - TICK_ALIGN,
        }, {
            size: tickSize + EDGE_TICK_ALIGN,
            x: scaleEnd,
            y: y - TICK_ALIGN,
        });
    }
    return {
        ticks: ticks,
        ticksPrecision: ticksPrecision,
    };
};
export default generateTicks;
